var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMostAffordableOption({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-business-1115708",
    transform: "translate(-46.15 -46.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12279",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12279",
    d: "M287.275,203.14h-5.4a.542.542,0,0,1-.54-.544v-2.5a1.626,1.626,0,0,0-.763-1.382,7.638,7.638,0,0,1,3.141-14.037,7.46,7.46,0,0,1,5.9,1.894,7.66,7.66,0,0,1-1.034,12.143,1.629,1.629,0,0,0-.765,1.383v2.5a.542.542,0,0,1-.54.544Zm-4.857-1.089h4.318V200.1a2.712,2.712,0,0,1,1.272-2.306,6.566,6.566,0,0,0,.887-10.409,6.386,6.386,0,0,0-5.06-1.622,6.546,6.546,0,0,0-2.687,12.032,2.711,2.711,0,0,1,1.27,2.3Z",
    transform: "translate(-225.427 -135.213)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12280",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12280",
    d: "M467,926.31h-4.355a1.09,1.09,0,0,1-1.089-1.089v-1.089a1.09,1.09,0,0,1,1.089-1.089H467a1.09,1.09,0,0,1,1.089,1.089v1.089A1.09,1.09,0,0,1,467,926.31Zm-4.355-2.178v1.089H467v-1.089Z",
    transform: "translate(-405.674 -856.336)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12281",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12281",
    d: "M510.985,1018.61h-2.178a1.09,1.09,0,0,1-1.089-1.089v-1.089a1.09,1.09,0,0,1,1.089-1.089h2.178a1.09,1.09,0,0,1,1.089,1.089v1.089A1.09,1.09,0,0,1,510.985,1018.61Zm-2.178-2.178v1.089h2.178v-1.089Z",
    transform: "translate(-450.746 -946.458)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12282",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12282",
    d: "M577.466,48.33a.544.544,0,0,1-.544-.544V46.7a.544.544,0,0,1,1.089,0v1.089A.544.544,0,0,1,577.466,48.33Z",
    transform: "translate(-518.317 0)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12283",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12283",
    d: "M920.147,203.467a.544.544,0,0,1-.385-.929l.77-.77a.544.544,0,1,1,.77.77l-.77.77A.543.543,0,0,1,920.147,203.467Z",
    transform: "translate(-852.979 -151.789)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12284",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12284",
    d: "M1063.2,578.013h-1.089a.544.544,0,1,1,0-1.089h1.089a.544.544,0,0,1,0,1.089Z",
    transform: "translate(-991.597 -518.316)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12285",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12285",
    d: "M47.783,578.013H46.694a.544.544,0,1,1,0-1.089h1.089a.544.544,0,1,1,0,1.089Z",
    transform: "translate(0 -518.316)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12286",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12286",
    d: "M202.944,203.467a.543.543,0,0,1-.385-.16l-.77-.77a.544.544,0,0,1,.77-.77l.77.77a.544.544,0,0,1-.385.929Z",
    transform: "translate(-151.812 -151.789)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12287",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12287",
    d: "M487.119,314.567v-.742a4.409,4.409,0,0,1-2.5-1.108l.741-.884a3.517,3.517,0,0,0,1.757.884v-1.971a4.14,4.14,0,0,1-1.681-.721,1.631,1.631,0,0,1-.533-1.326,1.852,1.852,0,0,1,.614-1.437,2.486,2.486,0,0,1,1.6-.61v-.508h.65v.518a4.245,4.245,0,0,1,2.113.761l-.66.935a3.272,3.272,0,0,0-1.452-.589v1.909h.031a4.118,4.118,0,0,1,1.716.741,1.682,1.682,0,0,1,.549,1.356,1.845,1.845,0,0,1-.63,1.447,2.621,2.621,0,0,1-1.666.609v.732Zm-.717-6.556a.727.727,0,0,0-.259.569.716.716,0,0,0,.2.538,2.045,2.045,0,0,0,.772.381v-1.757a1.219,1.219,0,0,0-.717.269Zm2.138,4.453a.785.785,0,0,0,.061-1.153,2.243,2.243,0,0,0-.833-.391v1.828a1.421,1.421,0,0,0,.772-.284Z",
    transform: "translate(-428.192 -253.907)",
    fill: "#1d1d1f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMostAffordableOption);
export default __webpack_public_path__ + "static/media/icoMostAffordableOption.29ab2de974a781874848508a6def8b43.svg";
export { ForwardRef as ReactComponent };